
// IMPORTANT: This is the language we settled on, don't change it without running it by
// Phil/Gab/Greg
// const archivalTerm = 'Lifetime Archival';

// tslint:disable-next-line:max-line-length
const query = JSON.stringify({ operationName: null, variables: null, query: 'query LicensePresets {\n  viewer {\n    license_presets {\n      ...licensePreset\n    }\n  }\n}\n\nfragment licensePreset on LicensePreset {\n  enabled\n  medium {\n    ...licensePresetComponent\n  }\n  spot_count {\n    ...licensePresetComponent\n  }\n  term {\n    ...licensePresetComponent\n  }\n  contextual_param {\n    ...licensePresetComponent\n  }\n  contextual_param_type\n}\n\nfragment licensePresetComponent on LicensePresetComponent {\n  internal_id\n  label\n  value_label\n  autodetect\n  locked\n}' });

export const licensePresets = { presets: [] };

(function loadLicensePresets() {
  function reqListener() {
    licensePresets.presets = JSON.parse(this.responseText).data.viewer.license_presets;
  }

  const req = new XMLHttpRequest();
  req.addEventListener('load', reqListener);
  req.open('POST', '/graphql');
  req.setRequestHeader('Content-Type', 'application/json');
  req.send(query);
})();

export const defaultLicensePresets = (location: ILicenseComponent) => {
  const presets = licensePresets.presets.map((preset: any) => {
    if (preset.contextual_param.length === undefined) {
      if (preset.contextual_param_type === 'ProducerLocation') {
        preset.contextual_param = {
          ...preset.contextual_param,
          internal_id: location.id,
          value_label: location.name,
        };
      }

      preset.contextual_param = [{
        ...preset.contextual_param,
        id: preset.contextual_param.internal_id,
      }];
    }

    ['medium', 'term', 'spot_count'].forEach((param) => {
      if (preset[param] && preset[param].internal_id) {
        preset[param] = {
          ...preset[param],
          id: preset[param].internal_id,
          name: preset[param].label,
        };
      } else {
        delete preset[param];
      }
    });

    return preset;
  });

  return presets.filter((preset) => preset.enabled);
};

// export const defaultLicensePresets = (location: ILicenseComponent) => [
//   {
//     medium: {
//       id: 2012,
//       name: 'Social Media',
//     },
//     spot_count: {
//       id: 1,
//       name: '1 film',
//     },
//     term: {
//       id: 1005,
//       name: `1 Year + ${archivalTerm}`,
//     },
//     contextual_param_type: 'ProducerLocation',
//     contextual_param_label: 'Location',
//     contextual_param: [{
//       id: location.id,
//       name: location.name,
//     }],
//   },
//   // {
//   //   medium: {
//   //     id: 2004,
//   //     name: 'Web Streaming',
//   //   },
//   //   spot_count: {
//   //     id: 1,
//   //     name: '1 film',
//   //   },
//   //   term: {
//   //     id: 1005,
//   //     name: `1 Year + ${archivalTerm}`,
//   //   },
//   //   contextual_param_type: 'ProducerLocation',
//   //   contextual_param_label: 'Location',
//   //   contextual_param: [{
//   //   id: location.id,
//   //   name: location.name,
//   //   }],
//   // },
//   {
//     medium: {
//       id: 2013,
//       name: 'TV Show',
//     },
//     contextual_param_type: 'EpisodeBudget',
//     contextual_param_label: 'Episode Budget',
//     contextual_param: [{
//       id: 7003,
//       name: '200K to 400K',
//     }],
//   },
// ] as ILicenseUsage[];



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/organisms/forms/LicensePresetsMenu/default-presets.ts